import React from "react";
import "./App.css";
import Home from "./components/home/home";
import Footer from "./components/footer/footer";
import EmailVerification from "./components/verification/email";
import Dashboard from "./components/dashboard/dashboard";
import Settings from "./components/settings/settings";
import TextChat from "./components/chat/textchat";
import ForgotPassword from "./components/verification/forgot";
import ResetPassword from "./components/verification/reset";
import VoiceChat from "./components/chat/voicechat";
import NewPassword from "./components/verification/password";
import KgpMap from "./components/kgpmap/kgpmap";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom"

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/set-new-password" element={<NewPassword/>}/>
          <Route path="/email-verification" element={<ResetPassword/>}/>
          <Route path="/forgot-password" element={<ForgotPassword/>}/>
          <Route path="/chat-voice" element={<VoiceChat/>}/>
          <Route path="/chat-text" element={<TextChat/>}/>
          <Route path="/legend-of-kgp" element={<KgpMap/>}/>
          <Route path="/my-account" element={<Settings/>}/>
          <Route path="/dashboard" element={<Dashboard/>}/>
          <Route path="/verify-email" element={<EmailVerification/>}/>
          <Route path="/" element={<Home/>}/>
        </Routes>
        <Footer />
      </Router> 
    </div>
  );
}

export default App;
